import { SECTION4 } from "../../content/copy";
import { Reveal } from "../Reveal";
import { SplitHeadline } from "../fx/SplitHeadline";
import { SectionMark, Folio, RegMarks } from "../fx/Marginalia";

const INITIALS = ["E", "I", "C"];

export const FacultyIndex = () => (
  <section className="sec fac-sec bg-b" data-testid="section-faculties" data-rail="04">
    <RegMarks />
    <div className="frame">
      <SectionMark n="04" label="FACOLTÀ" />
      <div className="g12 fac-head">
        <SplitHeadline as="h2" className="fac-title" text={SECTION4.title} emIdx={[8, 9, 10, 11]} testid="section4-title" />
        <Reveal as="p" className="fac-intro serif" delay={200} data-testid="section4-intro">{SECTION4.intro}</Reveal>
      </div>
      <ol className="fac-list">
        {SECTION4.faculties.map((f, i) => (
          <Reveal as="li" key={f.id} className={`fac fac-${i + 1}`} data-testid={`faculty-entry-${i + 1}`}>
            <span className="fac-initial serif" aria-hidden="true">{INITIALS[i]}</span>
            <span className="fac-num mono" aria-hidden="true">{`0${i + 1} / 03`}</span>
            <p className="fac-text serif" data-testid={`faculty-${f.id}`}>
              <span className="fac-name">{f.name}</span> {f.text}
            </p>
          </Reveal>
        ))}
      </ol>
      <Folio n="04" />
    </div>
  </section>
);
